import React from "react";

export const Loading = () => {
  return (
    <>
      <div className="background-blur w-full h-full h-screen flex items-center justify-center">
        <p className="text-3xl sm:text-5xl special-elite text-white font-bold">
          The Whispering Glass
        </p>
      </div>
    </>
  );
};
